// import { FaSuitcaseRolling, FaBuilding, FaCalendarCheck } from 'react-icons/fa';
// import { LuUsers } from 'react-icons/lu';
// import { useLoaderData, redirect } from 'react-router-dom';
// import {customFetch} from '../utils/custom-fetch';
// import Wrapper from '../assets/wrappers/StatsContainer';
// import { toast } from 'react-toastify';
// import { StatItem } from '../components';

// export const loader = async () => {
//   try {
//     const response = await customFetch.get('/users/admin/app-stats');
//     return response.data;
//   } catch (error) {
//     toast.error('אין לך גישה לגשת לדף זה');
//     return redirect('/dashboard');
//   }
// };

// const Admin = () => {
//   const { users, buildings } = useLoaderData();
//   return (
//     <Wrapper>
//       <StatItem
//         title='מספר בניינים'
//         count={buildings}
//         color='#647acb'
//         bcg='#e0e8f9'
//         icon={<FaBuilding />}
//       />
//       <StatItem
//         title='מספר משתמשים'
//         count={users}
//         color='#e9b949'
//         bcg='#fcefc7'
//         icon={<LuUsers />}
//       />
//     </Wrapper>
//   );
// };

// export default Admin;


import { FaBuilding, FaCalendarCheck, FaRegCalendarTimes, FaGlobe, FaSuitcaseRolling } from 'react-icons/fa';
import { LuUsers } from 'react-icons/lu';
import { useLoaderData, redirect } from 'react-router-dom';
import { customFetch } from '../utils/custom-fetch';
import Wrapper from '../assets/wrappers/StatsContainer';
import { toast } from 'react-toastify';
import { StatItem } from '../components';

export const loader = async () => {
  try {
    const response = await customFetch.get('/users/admin/app-stats');
    return response.data;
  } catch (error) {
    toast.error('אין לך גישה לגשת לדף זה');
    return redirect('/dashboard');
  }
};

const Admin = () => {
  const {
    users,
    buildings,
    totalCampaigns,
    campaignsWithoutSchedule,
    totalSchedules,
    activeSchedules,
    globalSchedules,
    nonGlobalSchedules,
    buildingsWithSchedules,
    campaignsByStatus,
    campaignsWithVideo,
    campaignsWithImage,
  } = useLoaderData();

  return (
    <Wrapper>
      {/* משתמשים ובניינים */}
      <StatItem
        title='מספר משתמשים'
        count={users}
        color='#e9b949'
        bcg='#fcefc7'
        icon={<LuUsers />}
      />
      <StatItem
        title='מספר בניינים'
        count={buildings}
        color='#647acb'
        bcg='#e0e8f9'
        icon={<FaBuilding />}
      />

      {/* קמפיינים */}
      <StatItem
        title='סה"כ קמפיינים'
        count={totalCampaigns}
        color='#3b82f6'
        bcg='#dbeafe'
        icon={<FaSuitcaseRolling />}
      />
      <StatItem
        title='קמפיינים ללא תזמון'
        count={campaignsWithoutSchedule}
        color='#ef4444'
        bcg='#fee2e2'
        icon={<FaRegCalendarTimes />}
      />
      <StatItem
        title='קמפיינים עם וידאו'
        count={campaignsWithVideo}
        color='#10b981'
        bcg='#d1fae5'
        icon={<FaCalendarCheck />}
      />
      <StatItem
        title='קמפיינים עם תמונות'
        count={campaignsWithImage}
        color='#d97706'
        bcg='#ffedd5'
        icon={<FaCalendarCheck />}
      />
      
      {/* תזמונים */}
      <StatItem
        title='סה"כ תזמונים'
        count={totalSchedules}
        color='#8b5cf6'
        bcg='#ede9fe'
        icon={<FaCalendarCheck />}
      />
      <StatItem
        title='תזמונים פעילים'
        count={activeSchedules}
        color='#14b8a6'
        bcg='#ccfbf1'
        icon={<FaCalendarCheck />}
      />
      <StatItem
        title='תזמונים גלובליים'
        count={globalSchedules}
        color='#6366f1'
        bcg='#e0e7ff'
        icon={<FaGlobe />}
      />
      <StatItem
        title='תזמונים מקומיים'
        count={nonGlobalSchedules}
        color='#f43f5e'
        bcg='#ffe4e6'
        icon={<FaBuilding />}
      />
      <StatItem
        title='בניינים מתוזמנים'
        count={buildingsWithSchedules}
        color='#22c55e'
        bcg='#dcfce7'
        icon={<FaBuilding />}
      />

      {/* סטטוס קמפיינים */}
      <StatItem
        title='קמפיינים ממתינים'
        count={campaignsByStatus['ממתין'] || 0}
        color='#f59e0b'
        bcg='#fef3c7'
        icon={<FaSuitcaseRolling />}
      />
      <StatItem
        title='קמפיינים פעילים'
        count={campaignsByStatus['פעיל'] || 0}
        color='#10b981'
        bcg='#d1fae5'
        icon={<FaSuitcaseRolling />}
      />
      <StatItem
        title='קמפיינים שהושלמו'
        count={campaignsByStatus['הושלם'] || 0}
        color='#3b82f6'
        bcg='#dbeafe'
        icon={<FaSuitcaseRolling />}
      />
    </Wrapper>
  );
};

export default Admin;
